// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { useCallback, useMemo, useState } from 'react'
import { sortData } from '../helpers'

const useStatusesTable = data => {
  const [tableSort, setTableSort] = useState({
    asc: true,
    col: '',
  })

  // handles sorting of this table
  const handleSort = useCallback(newCol => (
    setTableSort(({ asc, col }) => ({
      col: newCol,
      asc: newCol !== col ? true : !asc,
    }))
  ), [])

  // memoizes the sorted data based on tableSort
  const sortedData = useMemo(() => (
    sortData(data, tableSort)
  ), [data, tableSort])

  return {
    handleSort,
    sortedData,
    tableSort,
  }
}

export default useStatusesTable
